(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["somdul-catalog-browser"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('somdul-category-browser')) {
    customElements.define('somdul-category-browser', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) {
          this.media.addEventListener('change', this.onBreakpoint);
          window.addEventListener('popstate', this.onPopState);
          this.onBreakpoint();
          this.setState(this.readLocation(), { history: false });
          return;
        }
        this.ready = true;
        this.cards = Array.from(this.querySelectorAll('[data-scb-card]'));
        this.departments = new Map(Array.from(this.querySelectorAll('[data-scb-dept]')).map(button => [button.dataset.scbDept, button.dataset.deptLabel]));
        this.items = new Map(this.cards.map(card => [card.dataset.item, { department: card.dataset.department, label: card.dataset.title }]));
        this.packLabels = new Map(Array.from(this.querySelectorAll('[data-scb-pack]')).map(input => [input.value, input.dataset.packLabel]));
        this.initialDept = this.departments.has(this.dataset.initialDept) ? this.dataset.initialDept : 'all';
        this.disclosure = this.querySelector('[data-scb-disclosure]');
        this.media = window.matchMedia('(max-width: 749px)');
        this.onBreakpoint = () => { this.disclosure.open = !this.media.matches; };
        this.onBreakpoint();
        this.media.addEventListener('change', this.onBreakpoint);
        this.querySelectorAll('[data-scb-control]').forEach(control => { control.disabled = false; });
        this.querySelectorAll('[data-scb-dept]').forEach(button => button.addEventListener('click', () => this.setState({ dept: button.dataset.scbDept, sub: '', page: 1 })));
        this.querySelectorAll('[data-scb-all]').forEach(button => button.addEventListener('click', () => this.setState({ dept: 'all', sub: '', page: 1 })));
        this.querySelectorAll('[data-scb-parent]').forEach(button => button.addEventListener('click', () => this.setState({ sub: '', page: 1 })));
        this.querySelectorAll('[data-scb-department-all]').forEach(button => button.addEventListener('click', () => this.setState({ dept: button.dataset.scbDepartmentAll, sub: '', page: 1 })));
        this.querySelectorAll('[data-scb-sub], [data-scb-chip]').forEach(button => button.addEventListener('click', () => {
          this.setState({ dept: button.dataset.department, sub: button.dataset.scbSub || button.dataset.scbChip, page: 1 });
          if (this.media.matches && button.hasAttribute('data-scb-sub')) {
            this.disclosure.open = false;
            this.querySelector('[data-scb-title]').focus({ preventScroll: true });
          }
        }));
        this.querySelectorAll('[data-scb-pack]').forEach(input => input.addEventListener('change', () => this.setState({ pack: input.value, page: 1 })));
        this.querySelectorAll('[data-scb-view]').forEach(button => button.addEventListener('click', () => this.setState({ view: button.dataset.scbView })));
        this.querySelectorAll('[data-scb-reset]').forEach(button => button.addEventListener('click', () => {
          this.setState({ dept: 'all', sub: '', pack: 'any', q: '', page: 1 });
          if (button.closest('[data-scb-empty]') || button.closest('[data-scb-active]')) this.querySelector('[data-scb-search]').focus({ preventScroll: true });
        }));
        this.searchInput = this.querySelector('[data-scb-search]');
        this.searchInput.addEventListener('input', () => this.setState({ q: this.searchInput.value, page: 1 }, { history: 'replace' }));
        this.searchInput.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); this.setState({ q: this.searchInput.value, page: 1 }); } });
        this.querySelector('[data-scb-search-button]').addEventListener('click', () => this.setState({ q: this.searchInput.value, page: 1 }));
        this.querySelector('[data-scb-previous]').addEventListener('click', () => { this.setState({ page: this.state.page - 1 }); this.querySelector('[data-scb-pages] [aria-current]').focus({ preventScroll: true }); });
        this.querySelector('[data-scb-next]').addEventListener('click', () => { this.setState({ page: this.state.page + 1 }); this.querySelector('[data-scb-pages] [aria-current]').focus({ preventScroll: true }); });
        this.onPopState = () => this.setState(this.readLocation(), { history: false });
        window.addEventListener('popstate', this.onPopState);
        this.setState(this.readLocation(), { history: false });
      }
      disconnectedCallback() {
        this.media?.removeEventListener('change', this.onBreakpoint);
        window.removeEventListener('popstate', this.onPopState);
      }
      defaults() { return { dept: this.initialDept, sub: '', pack: 'any', q: '', view: 'grid', page: 1 }; }
      readLocation() {
        const params = new URL(window.location.href).searchParams;
        const state = this.defaults();
        if (params.has('dept')) state.dept = params.get('dept');
        if (params.has('sub')) state.sub = params.get('sub');
        if (params.has('pack')) state.pack = params.get('pack');
        if (params.has('q')) state.q = params.get('q');
        if (params.has('layout')) state.view = params.get('layout');
        if (params.has('page')) state.page = Number(params.get('page'));
        return state;
      }
      getState() { return { ...this.state }; }
      setState(next = {}, options = {}) {
        const merged = { ...this.defaults(), ...this.state, ...next };
        const dept = this.departments.has(merged.dept) ? merged.dept : this.initialDept;
        const item = this.items.get(merged.sub);
        this.state = {
          dept,
          sub: item && (dept === 'all' || item.department === dept) ? merged.sub : '',
          pack: this.packLabels.has(merged.pack) ? merged.pack : 'any',
          q: typeof merged.q === 'string' ? merged.q.slice(0, 100) : '',
          view: merged.view === 'list' ? 'list' : 'grid',
          page: Number.isSafeInteger(Number(merged.page)) && Number(merged.page) > 0 ? Number(merged.page) : 1
        };
        if (this.state.sub && this.state.dept === 'all') this.state.dept = this.items.get(this.state.sub).department;
        if (!Object.hasOwn(next, 'page') && ['dept', 'sub', 'pack', 'q'].some(key => Object.hasOwn(next, key))) this.state.page = 1;
        this.render();
        if (options.history !== false) this.syncLocation(options.history === 'replace' ? 'replaceState' : 'pushState');
        this.syncLanguageReturn();
        this.dispatchEvent(new CustomEvent('somdul:catalog-state-change', { bubbles: true, detail: this.getState() }));
      }
      stateQuery() {
        const params = new URLSearchParams();
        if (this.state.dept !== this.initialDept) params.set('dept', this.state.dept);
        if (this.state.sub) params.set('sub', this.state.sub);
        if (this.state.pack !== 'any') params.set('pack', this.state.pack);
        if (this.state.q) params.set('q', this.state.q);
        if (this.state.view !== 'grid') params.set('layout', this.state.view);
        if (this.state.page > 1) params.set('page', String(this.state.page));
        const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (/^\d+$/.test(previewId || '')) params.set('preview_theme_id', previewId);
        return params;
      }
      syncLocation(method) {
        const url = new URL(window.location.href);
        url.search = this.stateQuery().toString();
        if (url.href === window.location.href) return;
        try { window.history[method](window.history.state, '', url.pathname + url.search + url.hash); } catch (_) {}
      }
      syncLanguageReturn() {
        const url = new URL(window.location.href);
        url.search = this.stateQuery().toString();
        document.querySelectorAll('form[id$="LanguageForm"] input[name="return_to"]').forEach(input => {
          const form = input.form;
          if (!form || new URL(form.action, window.location.href).origin !== url.origin) return;
          input.value = url.pathname + url.search;
        });
      }
      render() {
        const state = this.state;
        const normalise = value => value.normalize('NFKC').toLocaleLowerCase().trim();
        const search = normalise(state.q);
        const matches = this.cards.filter(card => (state.dept === 'all' || card.dataset.department === state.dept) && (!state.sub || card.dataset.item === state.sub) && (!search || normalise(card.dataset.title + ' ' + card.dataset.alias + ' ' + this.departments.get(card.dataset.department)).includes(search)));
        const pages = Math.max(1, Math.ceil(matches.length / 12));
        state.page = Math.min(state.page, pages);
        const offset = (state.page - 1) * 12;
        const visible = new Set(matches.slice(offset, offset + 12));
        this.cards.forEach(card => {
          card.hidden = !visible.has(card);
          const pack = state.pack === 'any' ? 'single' : state.pack;
          card.dataset.pack = pack;
          card.querySelector('[data-scb-card-pack]').textContent = this.packLabels.get(pack);
          card.querySelectorAll('a').forEach(link => {
            const url = new URL(link.getAttribute('href'), window.location.href);
            url.searchParams.set('pack', pack);
            link.href = url.pathname + url.search + url.hash;
          });
        });
        this.querySelector('[data-scb-grid]').dataset.layout = state.view;
        this.searchInput.value = state.q;
        this.querySelector('[data-scb-count]').textContent = this.dataset.countLabel.replace('[from]', String(matches.length ? offset + 1 : 0)).replace('[to]', String(Math.min(offset + 12, matches.length))).replace('[count]', String(matches.length));
        this.querySelector('[data-scb-empty]').hidden = matches.length > 0;
        const departmentLabel = this.departments.get(state.dept);
        const itemLabel = this.items.get(state.sub)?.label;
        this.querySelector('[data-scb-title]').textContent = itemLabel || departmentLabel;
        this.querySelector('[data-scb-dept-crumb]').hidden = state.dept === 'all';
        this.querySelector('[data-scb-dept-crumb] button').textContent = departmentLabel;
        this.querySelector('[data-scb-sub-crumb]').hidden = !state.sub;
        this.querySelector('[data-scb-sub-label]').textContent = itemLabel || '';
        const catalogCrumb = this.querySelector('[data-scb-all]');
        const departmentCrumb = this.querySelector('[data-scb-dept-crumb] button');
        catalogCrumb.removeAttribute('aria-current');
        departmentCrumb.removeAttribute('aria-current');
        if (state.dept === 'all') catalogCrumb.setAttribute('aria-current', 'page');
        else if (!state.sub) departmentCrumb.setAttribute('aria-current', 'page');
        this.querySelectorAll('[data-scb-dept]').forEach(button => {
          const active = button.dataset.scbDept === state.dept;
          if (active) button.setAttribute('aria-current', 'page'); else button.removeAttribute('aria-current');
          if (button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', String(active));
          const icon = button.querySelector('[data-scb-dept-icon]');
          if (icon) icon.textContent = active ? '−' : '+';
        });
        this.querySelectorAll('[data-scb-children]').forEach(children => { children.hidden = children.dataset.scbChildren !== state.dept; });
        this.querySelectorAll('[data-scb-sub]').forEach(button => { if (button.dataset.scbSub === state.sub) button.setAttribute('aria-current', 'page'); else button.removeAttribute('aria-current'); });
        this.querySelectorAll('[data-scb-department-all]').forEach(button => { if (button.dataset.scbDepartmentAll === state.dept && !state.sub) button.setAttribute('aria-current', 'page'); else button.removeAttribute('aria-current'); });
        this.querySelector('[data-scb-subcategories]').hidden = state.dept === 'all';
        this.querySelector('[data-scb-all-chip]').setAttribute('aria-pressed', String(!state.sub));
        this.querySelectorAll('[data-scb-chip]').forEach(button => { button.hidden = button.dataset.department !== state.dept; button.setAttribute('aria-pressed', String(button.dataset.scbChip === state.sub)); });
        this.querySelectorAll('[data-scb-pack]').forEach(input => { input.checked = input.value === state.pack; });
        this.querySelectorAll('[data-scb-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.scbView === state.view)));
        const active = this.querySelector('[data-scb-active]');
        const activeChips = this.querySelector('[data-scb-active-chips]');
        activeChips.replaceChildren();
        const addChip = (label, patch) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = label + ' ×';
          button.setAttribute('aria-label', this.dataset.clearLabel + ': ' + label);
          button.addEventListener('click', () => { this.setState({ ...patch, page: 1 }); this.searchInput.focus({ preventScroll: true }); });
          activeChips.append(button);
        };
        if (state.dept !== 'all') addChip(departmentLabel, { dept: 'all', sub: '' });
        if (state.sub) addChip(itemLabel, { sub: '' });
        if (state.pack !== 'any') addChip(this.packLabels.get(state.pack), { pack: 'any' });
        if (state.q) addChip(this.dataset.searchLabel + ': ' + state.q, { q: '' });
        active.hidden = !activeChips.children.length;
        const pagination = this.querySelector('[data-scb-pagination]');
        pagination.hidden = pages <= 1;
        this.querySelector('[data-scb-previous]').disabled = state.page <= 1;
        this.querySelector('[data-scb-next]').disabled = state.page >= pages;
        const pageButtons = this.querySelector('[data-scb-pages]');
        pageButtons.replaceChildren();
        for (let page = 1; page <= pages; page += 1) {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = String(page);
          button.dataset.scbPage = String(page);
          button.setAttribute('aria-label', this.dataset.pageLabel + ' ' + page);
          if (page === state.page) button.setAttribute('aria-current', 'page');
          button.addEventListener('click', () => { this.setState({ page }); this.querySelector('[data-scb-pages] [aria-current]').focus({ preventScroll: true }); });
          pageButtons.append(button);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["somdul-language-inline"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.somdul-language-inline[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.somdul-language-inline[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
